import { atom } from 'recoil';

/**
 * Current authenticated user email.
 * Used by AuthStateSync.tsx and Login.tsx for reactive state tracking.
 * 
 * Note: The new permission system reads email directly from AuthContext.
 * This atom is kept for existing code that depends on Recoil-based email tracking.
 */
export const currentUserEmailAtom = atom<string | null>({
  key: 'currentUserEmailAtom',
  default: null,
});
